import React, { useRef } from "react";
import { FormikProps } from "formik";

import { useAppSelector } from "newui/store/hooks";
import SkeletonBase from "newui/components/Skeleton";
import CompanyInformationForm from "./CompanyInformationForm";

import type { Company, CompanyInformationFormValues } from "../../types";
import type { RootState } from "newui/store";

interface CompanyInformationFormContainerProps {
	formikRef?: React.MutableRefObject<unknown>;
}

const CompanyInformationFormContainer: React.FC<
	CompanyInformationFormContainerProps
> = ({ formikRef: externalRef }) => {
	const internalRef = useRef<FormikProps<CompanyInformationFormValues> | null>(null);
	const formikRef = (externalRef as React.MutableRefObject<FormikProps<CompanyInformationFormValues> | null>) ?? internalRef;

	const company = useAppSelector(
		(state: RootState) => state.search.activeCompany
	) as Company;

	if (!company?.id) {
		return (
			<div className="px-4">
				{Array.from({ length: 2 }).map((_, i) => (
					<div
						key={i}
						className="my-4 flex w-full items-center justify-between gap-8"
					>
						<div className="w-2/4">
							<div className="my-2">
								<SkeletonBase height="18px" />
							</div>
							<SkeletonBase width="100%" height="56px" />
						</div>
						<div className="w-2/4">
							<div className="my-2">
								<SkeletonBase height="18px" />
							</div>
							<SkeletonBase width="100%" height="56px" />
						</div>
					</div>
				))}
			</div>
		);
	}

	return (
		<CompanyInformationForm
			company={company}
			formikRef={formikRef}
		/>
	);
};

export default CompanyInformationFormContainer;
